var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.38878 0.257143L0.220408 3.42551C-0.0734696 3.71939 -0.0734696 4.19694 0.220408 4.49082C0.514286 4.78469 0.991837 4.78469 1.28571 4.49082L3.2602 2.51633L3.2602 8.24694C3.25102 8.6602 3.59082 9 4.00408 9C4.41735 9 4.75714 8.6602 4.75714 8.24694L4.75714 2.51633L6.72245 4.49082C7.01633 4.78469 7.49388 4.78469 7.78775 4.49082C7.93469 4.34388 8.00816 4.15102 8.00816 3.95816C8.00816 3.76531 7.93469 3.57245 7.78775 3.42551L4.61939 0.257143C4.45408 0.0918367 4.23367 -1.8506e-07 4.00408 -1.75024e-07C3.77449 -1.64988e-07 3.55408 0.0918368 3.38878 0.257143Z","fill":"black"}));
}

ArrowUp.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
